/** Company information */
export default class CompanyInformation {
    /** Name of the company */
    public static name = 'Adstelligence'
    /** Email of the company (TODO) */
    public static email = 'webmaster@hurx.io'
    /** Phone of the company (TODO) */
    public static phone = '+31612345678'
    /** The base for the platform */
    public static platformBase = process.env.CLIENT_BASE
    /** The base for the API */
    public static apiBase = process.env.SERVER_BASE
    /** The base for the assets */
    public static assetsBase = process.env.ASSETS_BASE
    /** The terms and conditions URL */
    public static terms = `${CompanyInformation.platformBase}/static/terms-and-conditions.pdf`
    /** The privacy policy URL */
    public static privacy = `${CompanyInformation.platformBase}/static/privacy-policy.pdf`
    /** The founding year of the company */
    public static founded = 2025
}